import React, { useState, useEffect } from 'react';

import './partialtext.css';

const PartialText = ({ text, className = '', onMore, dangerousHtml=false }) => {
  const [more,setMore]=useState(false);



  let spanElem = React.createRef();

  useEffect(() => {
    const currentWidth = spanElem.current.clientWidth;
    const parentElem = spanElem.current.parentElement;
    const padRight=parseInt(window.getComputedStyle(parentElem).getPropertyValue('padding-right'));
    const padLeft=parseInt(window.getComputedStyle(parentElem).getPropertyValue('padding-left'));
    const parentWidth = parentElem.clientWidth-padRight-padLeft;
    if(currentWidth > (parentWidth*.92)) {
      setMore(<span onClick={onMore} className="partial-read-more">more</span>)
    }

  }, []);

  // setTimeout(()=>{
  //   console.log(spanElem.current.clientWidth);
  // },2500);


  let finalClasses = 'partial-text';
  if (className) {
    finalClasses = finalClasses + ' ' + className;
  }

  if(more) {
    finalClasses = finalClasses + ' overflowed-text';
  }

  let ret=<span ref={spanElem} className={finalClasses}>{text}{more}</span>;
  
  if(dangerousHtml) {
    const htmlText=<span dangerouslySetInnerHTML={text}></span>
    ret=<span ref={spanElem} className={finalClasses}>{htmlText}{more}</span>;
  }
  

  return ret;
}

export default PartialText;